import React, { Component, createRef } from 'react';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Card } from 'primereact/card';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import BlockUi from '@availity/block-ui';   

import Help from '../../Navigation/Help';
import { cadenas } from '../../Utils/cadenas';
import { PATHS_API, ROLES, NUM_ROWS_POR_PAGINA, EDOS_COGNITO, MILLIS_RESET_DISABLED } from '../../Utils/constants';
import FormularioRegistro from '../../Components/FormularioRegistro';
import { APIGATEWAY } from '../../Api/ApiGateway';
import { getUsuarioLogueado } from '../../Utils/gestionSessionStorage';
import { UsuarioInterface } from '../../Interfaces/Usuario.interface';
import { Toast } from 'primereact/toast';
import { saveAs } from 'file-saver';
import { timestampDescarga } from '../../Utils/fechas';

/** Definir el tipo del catálogo ceoncesionarias. */
interface State {
    usuarios: Array<{}>;
    dialogVisible: boolean;
    id:string,
    codigoEmpresa:string|undefined;
    nombreCompleto:string;
    correo:string;
    telefono:string;
    usuario:string;
    blocking:boolean;
    [key: string]: any;
    tituloDialog: string;
    labelBtnAccion: string;
}

/**
 * @class
 * Componente de tipo clase para mostrar la pantalla donde se realiza
 * la administración de los usuarios de tipo INSPECTOR.
 */
class Inspector extends Component<{}, State> {
  private dataTable: any;

  private toast:any;
  exportToCSV = (data: any[], columnas: string[], encabezados: Record<string, string>, filenamePrefix: string) => {
      if (!data || data.length === 0) return;
      const now = new Date();
      const timestamp = timestampDescarga(); // Ej: 2025-10-02T11-12-00-000Z
      const filename = `${filenamePrefix}_${timestamp}.csv`;

      const headers = columnas.map((col) => encabezados[col] || col);
      const rows = data.map((row) => columnas.map((field) => `"${row[field] ?? ''}"`).join(','));
      const csvContent = [headers.join(','), ...rows].join('\n');
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

      saveAs(blob, filename);
  };
  constructor(props: any) {
    super(props);
    this.dataTable = createRef();

    this.state = {
      usuarios: [],
      dialogVisible: false,
      id: '',
      codigoEmpresa: '',
      nombreCompleto: '',
      correo: '',
      telefono: '',
      usuario: '',
      blocking: false,
      tituloDialog: '',
      labelBtnAccion: '',
    };
    this.toast = createRef();
    this.export = this.export.bind(this);
    this.limpiarFormulario = this.limpiarFormulario.bind(this);
    this.settearState = this.settearState.bind(this);
    this.showDialogNuevo = this.showDialogNuevo.bind(this);
    this.obtenerInspector = this.obtenerInspector.bind(this);
    this.validarRegistro = this.validarRegistro.bind(this);
    this.registrar = this.registrar.bind(this);
    this.eliminar = this.eliminar.bind(this);
    this.activarDesactivar = this.activarDesactivar.bind(this);
    this.resetear = this.resetear.bind(this);
  }

  /**
   * Limpiar las variables de estado.
   * */
  limpiarFormulario() {
    this.setState({
      id: '',
      codigoEmpresa: '',
      nombreCompleto: '',
      correo: '',
      telefono: '',
      usuario: '',
    });
  }

  /**
   * Función para acceder al valor de los inputs
   * del componente FormularioRegistro.
   */
  settearState(id: string, value: any) {
    this.setState({ [id]: value });
  }

  /**
   * Se ejecuta antes de renderizar el componente.
   */
  componentDidMount=async()=> {
      let res = await APIGATEWAY.validar();
      if (res){
        if (ROLES.ADMINDEALER === getUsuarioLogueado()?.rol) {
          this.setState({
            blocking: true,
            codigoEmpresa: getUsuarioLogueado()?.codigoEmpresa,
          });
          this.obtenerInspector();
        } else {
        }
      }
  }

  /**
   * Obtener los usuarios de tipo Inspector.
   */
  obtenerInspector() {
    const body = {
      usuario: '*',
    };
    console.log('Inspector -> obtenerInspector -> body', body);
    APIGATEWAY.post(PATHS_API.USUARIOS_API + '/leer', body)
      .then((response) => {
        console.log('Inspector -> obtenerInspector -> response', response);
        const datosFormateados = response.map((dato: Partial<Record<string, any>>) => {
          if (dato && typeof dato === 'object' && 'activo' in dato) {
            return {
              ...dato,
              activoFormatted: dato ? cadenas.ACTIVO_SI : cadenas.ACTIVO_NO,
            };
          }
          return dato;
        });

        this.setState({
          usuarios: datosFormateados,
          blocking: false,
        });
      })
      .catch((error) => {
        console.log('Inspector -> obtenerInspector -> error', error);
        this.setState({ blocking: false });
        this.showNotificacion(cadenas.GROWL_ERROR, cadenas.ERROR_TITULO, cadenas.INSPECTOR_ERROR_OBTENER_USUARIOS);
      });
  }

  /**
   * Validar el registro del usuario.
   * @param {React.FormEvent} event Evento submit del formulario.
   */
  validarRegistro(event: React.FormEvent) {
    event.preventDefault();
    let body: UsuarioInterface = {
      nombreCompleto: this.state.nombreCompleto,
      //correo: "",
      correo: this.state.correo,
      telefono: '+52'+this.state.telefono,
      usuario: '',
      rol: ROLES.INSPECTOR,
      codigoEmpresa: this.state.codigoEmpresa as string,
    };
    this.setState({ blocking: true });
    console.log('Inspector -> validarRegistro -> body', body);
    APIGATEWAY.post(PATHS_API.VALIDAR_USUARIO_SIGNUP, body)
      .then((usuarioValidado) => {
        console.log('Inspector -> validarRegistro -> usuarioValidado', usuarioValidado);
        this.registrar(usuarioValidado);
      })
      .catch((error) => {
        console.log('Inspector -> validarRegistro -> error', error);
        this.setState({ blocking: false });
        this.showNotificacion(cadenas.GROWL_ERROR, cadenas.ERROR_TITULO, error.response.data);
      });
  }

  /**
   * Registro del usuario.
   * @param {any} body Información del usuario para registrar.
   */
  registrar(body: any) {
    APIGATEWAY.post(PATHS_API.USUARIOS_API + '/crear', body)
      .then(() => {
        this.limpiarFormulario();
        this.setState({
          blocking: false,
          dialogVisible: false,
        });
        this.showNotificacion(cadenas.GROWL_SUCCESS, cadenas.EXITO_TITUTLO, cadenas.ACCION_EXITOSA);
        this.showNotificacion(
          cadenas.GROWL_SUCCESS,
          cadenas.EXITO_TITUTLO,
          cadenas.USUARIO_REGISTRADO + ' ' + body.correo
        );
        this.obtenerInspector();
      })
      .catch((error) => {
        this.limpiarFormulario();
        console.log('Inspector -> registrar -> error', error);
        this.setState({ blocking: false });
        this.showNotificacion(cadenas.GROWL_ERROR, cadenas.ERROR_TITULO, error.response.data);
      });
  }

  /**
   * Eliminar el usuario.
   * @param {any} rowData Instancia del row que pertenece al datatable.
   */
  eliminar(rowData: any) {
    this.setState({ blocking: true });
    let body = {
      usuario: rowData.usuario,
    };
    APIGATEWAY.post(PATHS_API.USUARIOS_API + '/borrar', body)
      .then(() => {
        this.setState({
          blocking: false,
          dialogVisible: false,
        });
        this.showNotificacion(cadenas.GROWL_SUCCESS, cadenas.EXITO_TITUTLO, cadenas.ACCION_EXITOSA);
        this.obtenerInspector();
      })
      .catch((error) => {
        console.log('Inspector -> eliminar -> error', error);
        this.setState({ blocking: false });
        this.showNotificacion(cadenas.GROWL_ERROR, cadenas.ERROR_TITULO, cadenas.INSPECTOR_ERROR_ELIMINACION);
      });
  }

  /**
   * Activar y desactivar según sea el caso del usuario de acuerdo a su
   * propiedad activo.
   * @param {any} rowData Instancia del row que pertenece al datatable.
   */
  activarDesactivar(rowData: any) {
    const body = {
      usuario: rowData.usuario,
    };
    const path = rowData.activo ? PATHS_API.USUARIOS_API + '/desactivar' : PATHS_API.USUARIOS_API + '/activar';
    APIGATEWAY.post(path, body)
      .then((response) => {
        console.log('Inspector -> activarDesactivar -> response', response);
        this.obtenerInspector();
        this.showNotificacion(cadenas.GROWL_SUCCESS, cadenas.EXITO_TITUTLO, cadenas.ACCION_EXITOSA);
      })
      .catch((error) => {
        console.log('Inspector -> activarDesactivar -> error', error);
        this.setState({ blocking: false });
        this.showNotificacion(cadenas.GROWL_ERROR, cadenas.ERROR_TITULO, cadenas.ACCION_NO_EXITOSA);
      });
  }

  /**
   * Resetear la contraseña del usuario.
   * @param {any} rowData Instancia del row que pertenece al datatable.
   */
  resetear(rowData: any) {
    const body = {
      usuario: rowData.usuario,
    };
    APIGATEWAY.post(PATHS_API.USUARIOS_API + '/reset', body)
      .then((response) => {
        console.log('Inspector -> resetear -> response', response);
        this.obtenerInspector();
        this.showNotificacion(cadenas.GROWL_SUCCESS, cadenas.EXITO_TITUTLO, cadenas.ACCION_EXITOSA);
        this.showNotificacion(
          cadenas.GROWL_SUCCESS,
          cadenas.EXITO_TITUTLO,
          cadenas.USUARIO_RESET + ' ' + rowData.correo
        );
      })
      .catch((error) => {
        console.log('Inspector -> resetear -> error', error);
        this.setState({ blocking: false });
        this.showNotificacion(cadenas.GROWL_ERROR, cadenas.ERROR_TITULO, cadenas.ACCION_NO_EXITOSA);
      });
  }

  /**
   * Mostrar la notificación de tipo Growl (componente del framewrok Prime React).
   * @param {string} type Tipo de la notificación.
   * @param {string} title Título de la notificación.
   * @param {string} message Mensaje de la notificación.
   */
  showNotificacion(type: string, title: string, message: string) {
    
    this.toast.current?.show({
      severity: type,
      summary: title,
      detail: message,
    });
  }

  /**
   * Exportar los datos del datatable a formato CSV.
   * @param {any} dataTable Referencia del datatable.
   */
  export() {
    const data = this.dataTable.current.props.value;
    if (data.every((u: any) => 'nombreCompleto' in u)) {
      const columnasExportadas = ['nombreCompleto', 'usuario', 'correo','telefono','rol','codigoEmpresa','estado','activoFormatted'];
      const encabezadosPersonalizados = {
        nombreCompleto: cadenas.INSPECTOR_DATA_NOMBRE_COMPLETO,
        usuario: cadenas.INSPECTOR_DATA_USUARIO,
        correo: cadenas.INSPECTOR_DATA_CORREO,
        telefono: cadenas.INSPECTOR_DATA_TELEFONO,
        rol: cadenas.INSPECTOR_DATA_ROL,
        codigoEmpresa: cadenas.INSPECTOR_DATA_CODIGO_EMPRESA,
        estado: cadenas.INSPECTOR_DATA_ESTADO,
        activoFormatted: cadenas.INSPECTOR_DATA_ACTIVO,
      };
      this.exportToCSV(data, columnasExportadas, encabezadosPersonalizados, 'inspectores');
    } else {
      this.dataTable.current.exportCSV();
    }
  }

  /**
   * Mostrar el dialog para registrar usuario.
   */
  showDialogNuevo() {
    this.setState({
      dialogVisible: true,
      tituloDialog: cadenas.INSPECTOR_DIALOG_NUEVO_TITULO,
      labelBtnAccion: cadenas.BTN_GUARDAR,
      codigoEmpresa: getUsuarioLogueado()?.codigoEmpresa,
    });
  }

  /**
   * Desactivar o activar boton de reset para cada usuario
   */
  activarReset(rowData: any) {
    let activar = true;
    if (rowData.activo) {
      if (rowData.estado === EDOS_COGNITO.RESET) {
        var diff = new Date().getTime() - rowData.fechaUltimoReset;
        if (diff > MILLIS_RESET_DISABLED) {
          activar = false;
        }
      } else if (rowData.estado !== EDOS_COGNITO.CREADO) {
        activar = false;
      }
    }
    return activar;
  }
  /**
   * Acción para salir del sistema.
   * @param {React.MouseEvent<HTMLButtonElement>} event Evento del botón HTML.
   */
  handleHelp = async (event: React.MouseEvent<HTMLButtonElement>) => {
    var currentLocation = window.location.pathname +"App";
    console.log('---> ruta actual: ', currentLocation);
    this.setState({
      pdfUrl: await Help(currentLocation),
    });
  };
  /**
   * @function
   * Función principal para renderizar el contenido del componente.
   */
  render() {
   
    const headerDatatable = (
      <div className="p-grid col-12" style={{display:'inline-flex'}}>
        <div className="col-8" style={{ textAlign: 'left' }}>
          <Button
            className="p-button p-button-rounded"
            label={cadenas.INSPECTOR_BTN_NUEVO}
            onClick={this.showDialogNuevo}
          />
        </div>
        <div className="col-4">
          <div className="col-12" style={{ textAlign: 'right' }}>
            <Button
              type="button"
              icon="pi pi-download"
              iconPos="left"
              onClick={(event) => this.handleHelp(event)}
              label="Manual app"
            >
              {' '}
            </Button>
          </div>
          <div className="col-12" style={{ textAlign: 'right' }}>
            <Button
              type="button"
              icon="pi pi-external-link"
              iconPos="left"
              label={cadenas.BTN_EXPORTAR_CSV}
              onClick={this.export}
            />
          </div>
        </div>
      </div>
    );
    const headerCard = (
      <div style={{ textAlign: 'center' }}>
        <h1>{cadenas.INSPECTOR_VISTA_TITULO}</h1>
      </div>
    );
    const footerDialog = (
      <div>
        <Button
          className="p-button p-button-success"
          label={this.state.labelBtnAccion}
          icon="pi pi-check"
          type="submit"
        />
        <Button
          type="button"
          className="p-button p-button-danger"
          label={cadenas.BTN_CANCELAR}
          icon="pi pi-times"
          onClick={(e) => {
            this.limpiarFormulario();
            this.setState({ dialogVisible: false });
          }}
        />
      </div>
    );
    const actionDatatable = (rowData: any, column: any) => {
      return (
        <div>
          <Button
            tooltip={rowData.activo ? cadenas.ADMINDEALER_BTN_DESACTIVAR : cadenas.ADMINDEALER_BTN_ACTIVAR}
            tooltipOptions={{ position: 'top' }}
            type="button"
            disabled={rowData.estado === EDOS_COGNITO.RESET}
            icon={rowData.activo ? 'pi pi-user-minus' : 'pi pi-user-plus'}
            className={rowData.activo ? 'p-button-danger' : 'p-button-success'}
            style={{ marginRight: '.5em' }}
            onClick={(e) => {
              if (window.confirm(cadenas.CONFIRMAR_ACCION)) {
                this.activarDesactivar(rowData);
              }
            }}
          />
          <Button
            tooltip={cadenas.ADMINDEALER_BTN_RESET}
            tooltipOptions={{ position: 'top' }}
            type="button"
            icon="pi pi-key"
            className="p-button-success"
            style={{ marginRight: '.5em' }}
            disabled={this.activarReset(rowData)}
            onClick={(e) => {
              if (window.confirm(cadenas.CONFIRMAR_ACCION)) {
                this.resetear(rowData);
              }
            }}
          />
          <Button
            tooltip={cadenas.BTN_ELIMINAR}
            tooltipOptions={{ position: 'top' }}
            type="button"
            icon="pi pi-trash"
            className="p-button-warning"
            onClick={(e) => {
              if (window.confirm(cadenas.CONFIRMAR_ACCION)) {
                this.eliminar(rowData);
              }
            }}
          />
        </div>
      );
    };
    return (
      <div>
        <BlockUi message="Cargando.." tag="div" blocking={this.state.blocking}>
          <Toast ref={this.toast} />
          <div className="p-grid">
            <div className="p-col-12">
              <Card header={headerCard} style={{ padding: '1em' }}>
                <div className="p-grid">
                  <div className="p-col-12">
                    <DataTable
                      filterDisplay="row"
                      value={this.state.usuarios}
                      paginator={true}
                      rows={NUM_ROWS_POR_PAGINA}
                      header={headerDatatable}
                      responsiveLayout="scroll"
                      ref={this.dataTable}
                      emptyMessage={cadenas.DATATABLE_VACIO}
                    >
                      <Column
                        showFilterMenu={false}
                        filterMatchMode="contains"
                        field="nombreCompleto"
                        header={cadenas.INSPECTOR_DATA_NOMBRE_COMPLETO}
                        filter={true}
                        sortable={true}
                      />
                      <Column
                        showFilterMenu={false}
                        filterMatchMode="contains"
                        field="usuario"
                        header={cadenas.INSPECTOR_DATA_USUARIO}
                        filter={true}
                        sortable={true}
                      />
                      <Column
                        showFilterMenu={false}
                        filterMatchMode="contains"
                        field="correo"
                        header={cadenas.INSPECTOR_DATA_CORREO}
                        filter={true}
                        sortable={true}
                      />
                      <Column
                        showFilterMenu={false}
                        filterMatchMode="contains"
                        field="telefono"
                        body={(rowData) => (rowData.telefono !== undefined ? rowData.telefono.slice(-10) : '')}
                        header={cadenas.INSPECTOR_DATA_TELEFONO}
                        filter={true}
                        sortable={true}
                      />
                      <Column
                        showFilterMenu={false}
                        filterMatchMode="contains"
                        field="rol"
                        header={cadenas.INSPECTOR_DATA_ROL}
                        filter={true}
                        sortable={true}
                      />
                      <Column
                        showFilterMenu={false}
                        filterMatchMode="contains"
                        field="codigoEmpresa"
                        header={cadenas.INSPECTOR_DATA_CODIGO_EMPRESA}
                        filter={true}
                        sortable={true}
                      />
                      <Column
                        showFilterMenu={false}
                        filterMatchMode="contains"
                        field="estado"
                        header={cadenas.INSPECTOR_DATA_ESTADO}
                        filter={true}
                        sortable={true}
                      />
                      <Column
                        showFilterMenu={false}
                        filterMatchMode="contains"
                        field="activoFormatted"
                        //body={(rowData: any, column: any) => (rowData.activo ? cadenas.ACTIVO_SI : cadenas.ACTIVO_NO)}
                        header={cadenas.INSPECTOR_DATA_ACTIVO}
                        style={{ width: '5em' }}
                      />
                      <Column body={actionDatatable} style={{ textAlign: 'center', width: '10em' }} />
                    </DataTable>
                  </div>
                </div>
              </Card>
            </div>

            <form onSubmit={this.validarRegistro}>
              <Dialog
                appendTo={document.body.querySelector('form')}
                header={this.state.tituloDialog}
                visible={this.state.dialogVisible}
                position="center"
                blockScroll={true}
                footer={footerDialog}
                style={{ width: '50vw' }}
                modal={true}
                onHide={() => {
                  this.limpiarFormulario();
                  this.setState({ dialogVisible: false });
                }}
              >
                <div className="p-fluid col-12">
                  <div className="col-12" style={{ display: 'inline-flex' }}>
                    <label htmlFor="codigoEmpresa" className="col-3">
                      {cadenas.INSPECTOR_DATA_CODIGO_EMPRESA}: *
                    </label>
                    <div className="col-9">
                      <InputText
                        id="codigoEmpresa"
                        type="text"
                        disabled={true}
                        required={true}
                        value={this.state.codigoEmpresa}
                        onChange={(e) => this.setState({ codigoEmpresa: (e.target as HTMLInputElement).value })}
                      />
                    </div>
                  </div>
                </div>
                <FormularioRegistro settearState={this.settearState} stateParent={this.state} />
              </Dialog>
            </form>
          </div>
        </BlockUi>
      </div>
    );
  }
}

export default Inspector;
